





























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import OptionSideBar from '@/layouts/gripper/components/QuickLabeling/OptionSideBar.vue';
import ImagesGrid from '@/layouts/gripper/components/QuickLabeling/ImagesGrid.vue';
import TaskElaboration from './components/TaskElaboration.vue';
import {Resource, Option} from '@/types/gripper';
import {
  JobDatasetSingleImage_job_dataset_resources_data as Resources_data,
  JobDatasetSingleImage, JobInfo,
  JobInfo_job_task_parameter,
  UpdateJobResourceCheckInput,
} from '@/types/intrador';
import MessageCategoryIsDone from '@/layouts/gripper/components/MessageCategoryIsDone.vue';
import DirectionSwitch from '@/layouts/back-office/misc/DirectionSwitch.vue';
import IntradorLoader from '@/layouts/gripper/components/QuickLabeling/IntradorLoader.vue';
import {SmartQuery} from 'vue-apollo/types/vue-apollo';
import PaginateButtonsShrinkingBin from '@/layouts/gripper/components/QuickLabeling/PaginateButtonsShrinkingBin.vue';
import OptionButtonBar from '@/layouts/gripper/components/QuickLabeling/OptionButtonBar.vue';


@Component({
  components: {
    OptionButtonBar,
    DirectionSwitch,
    MessageCategoryIsDone,
    TaskElaboration,
    ImagesGrid,
    OptionSideBar,
    IntradorLoader,
    PaginateButtonsShrinkingBin,
  },
  metaInfo: {
    title: 'Single Labelling',
  },
})

export default class SingleLabelling extends Vue {

  @Prop(Object) public jobInfo!: JobInfo;
  @Prop(Array) public options!: Option[];
  @Prop(Object) private parameter!: JobInfo_job_task_parameter;

  private JobDataset!: JobDatasetSingleImage;
  private selectedParameterOption: Option | null = null;
  private imagesData: Resource[] = [];

  private page: number = 1;
  private limit: number = 1;
  private totalPages: number = 0;


  private created() {
    if (this.options.length > 0) {
      this.selectedParameterOption = this.options[0];
    }
  }

  get queryVariables() {
    return {
      jobID: this.jobInfo!.job!.id,
      page: this.page,
      limit: this.limit,
      parameter_id: this.parameter.id,
    };
  }

  private get queryResult(): SmartQuery<any> {
    return (this.$refs.apolloQuery as any).getApolloQuery();
  }

  private get canChangePage(): boolean {
    return this.imagesData.every((resource) => !resource.isMutating) && this.selectedParameterOption !== null;
  }

  private refetch() {
    if (this.queryResult) {
      this.queryResult.refresh();
    }
  }

  private resolveData(data: JobDatasetSingleImage) {
    if (!data || !data.job || !data.job.dataset || !data.job.dataset.resources) {
      return false;
    }

    this.JobDataset = data;

    this.totalPages = Math.ceil(data.job.dataset.resources.paginatorInfo.total / this.limit);
    this.resolveImagesData(data);

    return data;
  }

  private resolveImagesData(data: JobDatasetSingleImage) {
    if (!data || !data.job || !data.job.dataset || !data.job.dataset.resources) {
      return false;
    }
    this.imagesData = [];

    data.job.dataset.resources.data.forEach((item: Resources_data) => {
      if (this.imagesData.findIndex((i: Resource) => i.id === item.id) < 0) {

        let newOption = null;
        if (item.values && item.values.length > 0) {
          newOption = this.options.find((i: Option) => i.value === item.values![0].value);
        }
        if (item.predictions && item.predictions.length > 0) {
          newOption = this.options.find((i: Option) => i.value === item.predictions![0].value);
        }
        if (newOption) {
          this.selectedParameterOption = newOption;
        }


        const resource: Resource = {
          id: item.id,
          url: item.url + '?job_id=' + data.job?.id,
          isSelected: false,
          isMutating: false,
          isDeleted: false,
          type: item.type,
        };
        this.imagesData.push(resource);
      }
    });

  }

  private changeOption(option: Option) {
    this.selectedParameterOption = option;
  }

  private async pageChange(newPage: number) {
    if (this.JobDataset &&
      this.JobDataset.job
      && this.JobDataset.job.dataset
      && this.JobDataset.job.dataset.resources
      && this.selectedParameterOption) {

      await this.persistToDatabase(this.imagesData[0]);

      this.page = newPage;
      this.imagesData = [];
      this.refetch();
    }
  }

  private async persistToDatabase(resource: Resource) {
    resource.isMutating = true;

    let variables = null;
    let query = null;

    query = require('@/graphql/mutations/UpdateJobResourceCheck.graphql');
    variables = this.resolveUpdateJobResourceCheckInput(resource);

    if (variables && query) {
      try {
        await this.$apollo.mutate({
          mutation: query,
          variables: {input: variables},
        });
      } catch (error) {
        await this.$swal('Error', error.message, 'warning');
      }
    }

    resource.isMutating = false;
  }

  private resolveUpdateJobResourceCheckInput(resource: Resource) {
    if (!this.JobDataset || !this.JobDataset.job) {
      return;
    }

    if (this.selectedParameterOption) {
      return {
        job_id: this.jobInfo!.job!.id,
        resource_id: resource.id,
        value: this.selectedParameterOption.value,
        option_id: this.selectedParameterOption.id,
      } as UpdateJobResourceCheckInput;
    }

    return false;
  }

}
